import { useGeneralRiskContext } from '../context/GeneralRiskContext';

export const useGeneralRisk = () => useGeneralRiskContext();
